import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";


const UserInvite = lazy(()=>import("src/layouts/myLeadershipSurvey/userInvite"));

export const _360UserInvite = [
  {
    path: "",
    element: (  
        <Suspense>    
          <Outlet />
        </Suspense>
    ),
    children: [
      {
        path: "MyLeadershipUserInvite",
        index: true,
        element: <UserInvite />,
      }
    ],
  },
];
